import React, { FunctionComponent } from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';
import { PrimaryButton } from 'app/common/components/controls/button/button';
import { OnboardingDialog } from './OnboardingDialog';
import { LinkWrapper } from 'app/common/components/singlespa/link-wrapper';

import { AtlassianAccountOnboardingLinks } from '../AtlassianAccountOnboardingLinks';
// eslint-disable-next-line @trello/less-matches-component
import styles from './AtlassianAccountOnboardingOverlay.less';

const format = forNamespace(['aa onboarding', 'dialog'], {
  shouldEscapeStrings: false,
});

interface NotWorkProps {
  aaEmail: string;
  orgName: string;
  onClickGoBack: () => void;
  onDismiss: () => void;
  onClickRemove: () => void;
}

export const NotWorkV2: FunctionComponent<NotWorkProps> = ({
  aaEmail,
  orgName,
  onClickGoBack,
  onDismiss,
  onClickRemove,
}) => (
  <OnboardingDialog
    onClickGoBack={onClickGoBack}
    title={format('remove org emails header', { org: orgName })}
    helpLink={AtlassianAccountOnboardingLinks.Help}
    closeDialog={onDismiss}
    className={styles.notWorkBody}
  >
    <div className={styles.notWorkContent}>
      {format('keep account personal')} {` ${aaEmail} `}
      {format('add personal email')}
    </div>
    <div className={styles.section}>
      <LinkWrapper href="/me" role="link">
        <PrimaryButton onClick={onClickRemove}>
          {format('go to profile')}
        </PrimaryButton>
      </LinkWrapper>
    </div>
  </OnboardingDialog>
);
